import { useEffect } from 'react'

/**
 * Injects a third-party script tag once per page and cleans it up on unmount.
 * Used for external widgets (callback services, chat, analytics) that ship as
 * a hosted script rather than an npm package.
 */
export function useExternalScript(src: string): void {
  useEffect(() => {
    if (typeof document === 'undefined') return
    if (document.querySelector(`script[src="${src}"]`)) return

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.charset = 'utf-8'
    document.body.appendChild(script)

    return () => {
      script.remove()
    }
  }, [src])
}
